<template>
    <section class="section-six">
        <div class="section-six--wrapper">
            <div class="section-six--left section-title">
                <div class="section-top-title">
                    <span class="title">Percorrenza media mensile</span>
                    <div class="iconTooltip__container" @click="toggleTooltip">
                        <span class="qrt-icon-Icona_Information">
                            <img src="../../../images/project-img/Icon-information-circle.png" alt="info icon" width="20px" />
                        </span>
                        <div class="tooltip" :class="{ 'tooltip-visible': tooltipVisible }">
                            Se mediamente percorri più chilometri rispetto alla media di mercato la tua auto si svaluterà più velocemente.
                        </div>
                    </div>
                </div>
                <span class="text-two">
                    Quanti chilometri medi percorri mensilmente? E quanti ne percorrono i veicoli comparati?<br /><br /><br /><br />
                </span>
            </div>
            <div class="section-six--right">
                <div class="six--right__one"></div>
                <div class="line" :style="{ left: generalAvgWidth + '%' }"></div>
                <div class="six--right__three" :style="redBarStyle"></div>
                <div class="genAvg-container" :style="{ left: generalAvgWidth + '%' }">
                    <div class="triangle-down--text">
                    <span class="text-four">Media km mese per questa auto</span>
                    <span class="number-four">{{ formatNumber(average.generalAvg) }} km</span>
                </div>
                <div class="triangle-down"></div>
                </div>
                <div class="myAvg-container" :style="{ left: myAvgTrianglePosition + '%' }">
                <div class="triangle-up" >
                </div>
                <div class="triangle-up--text">
                <span class="text-four">La tua media</span>
                <span class="number-four">{{ formatNumber(average.myAvg) }} km</span>
            </div>
            </div>
            </div>
        </div>
    </section>
    </template>


<script>
export default {
    name: 'LivemarketDataAverage',
    props: {
        average: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            tooltipVisible: false,
        };
    },
    computed: {
        maxKm() {
            const baseMax = this.average.generalAvg * 2;
            return Math.max(baseMax, this.average.myAvg);
        },
        generalAvgWidth() {
            return 50;
        },
        myAvgTrianglePosition() {
            const position = (this.average.myAvg / this.maxKm) * 100;
            return Math.min(position, 100);
        },
        redBarStyle() {
            const start = this.generalAvgWidth;
            const end = this.myAvgTrianglePosition;
            let leftPosition = Math.min(start, end);
            let width = Math.abs(start - end);
            return {
                width: `${width}%`,
                left: `${leftPosition}%`,
                backgroundColor: '#d20a11'
            };
        },
    },

    methods: {
        toggleTooltip() {
            this.tooltipVisible = !this.tooltipVisible;
        },
        formatNumber(value) {
      if (value === null || value === undefined) {
        return '';
      }
      const parts = value.toString().split('.');
      // Format the integer part with dots as thousands separators
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return parts.join('.');
    },
    },
}
</script>


<style scoped>
.section-six  {
    padding: 58px 0px 78px;
    margin: 0px 100px;
    position: relative;
}
.section-six--wrapper  {
    max-width: 830px;
    width: 100%;
    margin: auto;
    display: flex;
}
.section-six--left  {
    display: flex;
    flex-direction: column;
    width: 50%;
    padding-right: 8px;
}
.section-top-title  {
    display: flex;
    justify-content: space-between;
}
.section-six--left .section-top-title .title  {
    font-size: 1.2rem;
}

.section-top-title .title  {
    color: #d20a11;
    font-size: 21px;
    line-height: 28px;
    font-weight: bold;
}
.iconTooltip__container  {
    position: relative;
}
.section-six--left .qrt-icon-Icona_Information  {
    margin-top: 5px;
}

.qrt-icon-Icona_Information  {
    font-size: 20px;
    cursor: pointer;
}
.iconTooltip__container .tooltip  {
    visibility: hidden;
    width: 198px;
    padding: 20px 5px;
    background-color: #fff;
    color: #333;
    text-align: center;
    position: absolute;
    z-index: 1;
    bottom: 130%;
    left: -30px;
    margin-left: -60px;
    box-shadow: 0px 0px 6px #00000045;
    display: flex !important;
    justify-content: center;
    align-items: center;
    font-weight: 300;
}
.iconTooltip__container .tooltip ::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #fff transparent transparent transparent;
}
.iconTooltip__container .tooltip-visible {
  visibility: visible;
}

.section-six--left .text-two  {
    padding-right: 80px;
}

.text-two  {
    font-size: 0.875rem;
    line-height: 18px;
    margin-top: 5px;
}
.section-six--right {
    position: relative;
    height: 50px;
    width: 45%;
    margin:30px auto;
}
.six--right__one{
    width: 100%;
    background-color: #d9d9d9;
    height: 20px;
    position: absolute;
    top: 15px;
}
.six--right__three {
    position: absolute;
    bottom: 15px;
    height: 20px;
}

.line {
    position: absolute;
    bottom: 0;
    height: 50px;
    width: 2px;
    background-color: #707070;
}
.myAvg-container {
    position: absolute;
}
.genAvg-container{
    position: absolute;
}
.triangle-down,
.triangle-up {
    position: absolute;
    width: 0;
    height: 0;
}

.triangle-down {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-top: 11px solid #d20a11;
    top: -20px;
    transform: translateX(-5px);
}

.triangle-up {
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 11px solid #d20a11;
    top: 45px;
    transform: translateX(-5px);
}

.triangle-down--text,
.triangle-up--text {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.triangle-down--text{
    top: -60px;
    width: 250px;
    text-align: center;
    transform: translateX(-50%);
}
.triangle-up--text{
    top: 60px;
    width: 145px;
    text-align: center;
    transform: translateX(-50%);
}
.text-four {
    font-size: 15px;
    color: #333;
}

.number-four {
    font-size: 21px;
    color: #d20a11;
    font-weight: bold;
}

@media (max-width: 768px) {
    .section-six{
        margin: 0;
    }
    .section-six--wrapper{
        flex-direction: column;
    align-items: center;
    }
    .section-six--left{
        width: 85%;
    }
    .iconTooltip__container .tooltip{
        left: -125px;
    }
    .section-six--right {
        width:85% ;
    }
    .triangle-down,
    .triangle-up {
        bottom: -13px;
        top: unset;
    }
    .triangle-up {
        top: 37px;
    }
    .triangle-down--text {
    top: -50px;
    width: 130px;
    }
    .triangle-up--text {
        top: 50px;
    }
}

</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataAverage.vue